<template>
  <v-card>
    <GenericListTableV2
      :parentID="this.parentID"
      :title="`Device Types`"
      :headers="[
          { text: 'ID', value: 'id' },
          { text: 'Device Type Name', value: 'typename' },
          { text: 'Device Type Description', value: 'description', editable: true }
        ]"
      :url="`/schemas/devicetypes`"
      :apiResponseField="`devicetypes`"
      :onClickRoute="`DeviceTypeSingle`"
      :onClickParams="getOnClickParams">
    </GenericListTableV2>
  </v-card>
</template>

<script>
import GenericListTableV2 from '@/components/Common/GenericListTableV2'

export default {
  name: 'DeviceTypeListTable',
  components: { GenericListTableV2 },
  props: {
    parentID: {
      type: Number,
      default: null
    }
  },
  methods: {
    getOnClickParams (item) {
      return {
        id: item.id
      }
    }
  }
}
</script>
